import gql from "graphql-tag";

const CREATE_PRODUCT_MUTATION = gql` 
  mutation CreateProduct($productData: ProductInput!) {
      addProduct(productData:$productData){
        id
        name
        description
        code
        cost
        image{
            original
            thumbnail
            zoom
        }
        maxQty
        stepQty
        startDate
        endDate
        }
    } 
  `;
export default CREATE_PRODUCT_MUTATION;